module.exports = __webpack_public_path__ + "img/franco_risotto.04a4dca2.png";